export default "__VITE_ASSET__CBuBB4Ih__"